import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AppComponent } from '@app/app.component';
import { EmptyStringValidator, MustMatch } from '@app/_helpers';
import { ownerShipType, permissiblePurposes, Signup } from '@app/_models';
import { State } from '@app/_models/signups/geography';
import { AlertService, GeographyService, SignupService } from '@app/_services';
import { FadvCheckboxComponent, FadvIconLibraryService, FadvLoaderComponent, FadvModalComponent, FadvSignatureComponent } from '@fa-switch-sharedservices/ng-elements';
import { PartnerComponent } from '../partner.component';

@Component({
  selector: 'app-partner-account',
  templateUrl: './partner-account.component.html',
  styleUrls: ['./partner-account.component.css']
})
export class PartnerAccountComponent implements OnInit {

  ownershipTypes = ownerShipType;
  permissiblePurpose = permissiblePurposes;
  states: State[];
  form: UntypedFormGroup;
  signup: Signup;
  isChecked = false;
  @ViewChild('agreementmodal') agreementmodal!: FadvModalComponent;
  @ViewChild('esignmodal') esignmodal!: FadvModalComponent;
  @ViewChild('agreementsignmodal') agreementsignmodal!: FadvModalComponent;
  @ViewChild('loader') loader: FadvLoaderComponent;
  @ViewChild('agreementBox') agreementBox!: FadvCheckboxComponent;
  @ViewChild('signbox') signbox!: FadvSignatureComponent;
  loading = true;
  isDisabled = true;
  isSigned = "false";
  submitted = false;
  clientLegalFormGuid = "C814878C-2750-4E17-BFBF-FCA0CBD60B12";
  clientLegalFormHTML = "";
  esignLegalFormGuid = "C814878C-2750-4E17-BFBF-FCA0CBD60B13";
  eSignLegalFormHTML = "";
  selectedState = new State();
  hasMobilePhone = false;
  invalidTooltip = "Double check the following fields: ";
  invalidTooltipList = "";
  innerWidth: number = window.innerWidth;
  bottomRowPadding: string = "2%";
  emailInvalid: boolean = false;
  legalCompanyNameInvalid: boolean;
  billToZipInvalid: boolean = false;
  billToCityInvalid: boolean = false;
  billToAddressInvalid: boolean = false;
  clientFullName: string;
  showAgreementRestrictor: boolean = false;
  passwordInvalid: boolean = false;
  confirmPasswordInvalid: boolean = false;
  billToStateInvalid: boolean = false;
  mobilephonenumberInvalid: boolean = false;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private router: Router,
    private signupService: SignupService,
    private geographyService: GeographyService,
    private alertService: AlertService,
    private iconLibraryService: FadvIconLibraryService,
    private partnerComponent: PartnerComponent,
    private appComponent: AppComponent
  ) { }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.innerWidth = window.innerWidth;

    if (this.innerWidth <= 860) {
      this.bottomRowPadding = "5%";
    }
    else {
      this.bottomRowPadding = "2%"
    }
  }

  ngAfterViewInit(): void {
    this.partnerComponent.setStep(this.router.url)
  }

  ngOnInit(): void {
    this.handleGetSignup();
    this.handleServices();
    this.handleBuildForm();
    this.validatePayment();
    this.loading = false;
  }

  validatePayment() {
    if(!this.signup.hasCompletedPayment) {
      this.router.navigate(['/partner/payment']);
    }
  }

  handleGetSignup() {
    this.signup = this.signupService.getSignup();
    if (this.appComponent.partner == false) {
      this.handleRefresh();
    }
  }

  handleServices() {
    this.geographyService.getStates().subscribe(states => this.states = states);
    this.signupService.getLegalForm(this.esignLegalFormGuid).subscribe(x => {
      this.eSignLegalFormHTML = x;
    });
    this.iconLibraryService.useFontAwesome();
    this.iconLibraryService.setBasePath('/assets');
  }

  handleRefresh() {
    this.appComponent.partner = true;
    var logo = this.signup.partner.logoImageContentType + this.signup.partner.logo;
    this.appComponent.partnerLogo = logo;
  }

  handleBuildForm() {
    this.form = this.formBuilder.group({
      email: [this.signup != null && this.signup.email != undefined ? this.signup.email : '', [Validators.required, Validators.email]],
      password: ['', [Validators.required, hasLength, hasNumbers, hasSpecialCharacters, hasUpper, hasLower]],
      confirmPassword: ['', Validators.required],
      legalCompanyName: [this.signup != null && this.signup.legalCompanyName != undefined ? this.signup.legalCompanyName : this.signup.companyName, [Validators.required, EmptyStringValidator]],
      billToAddress: ['', [Validators.required, EmptyStringValidator]],
      billToCity: ['', [Validators.required, EmptyStringValidator]],
      billToState: [this.signup != null && this.signup.billToState != undefined ? this.signup.billToState : '', [Validators.required, Validators.pattern('[a-z A-Z]+$'), EmptyStringValidator]],
      billToZip: [this.signup != null && this.signup.billToZip != undefined ? this.signup.billToZip : '', [Validators.required, Validators.minLength(5), Validators.pattern(/^-?(|[0-9]\d*)?$/)]],
      ownershiptype: ['', Validators.required],
      stateofincorporation: [''],
      clientagreementpermissiblepurpose: [this.signup != null && this.signup.clientagreementpermissiblepurpose != undefined ? this.signup.clientagreementpermissiblepurpose : '', [Validators.required]],
      taxid_ein: [''],
      mobilephonenumber: ['', [Validators.pattern(/^-?(0|[1-9]\d*)?$/), Validators.minLength(10)]],
      agreement: [false, Validators.requiredTrue],
      authorization: [false, Validators.requiredTrue],
    }, {
      validator: MustMatch('password', 'confirmPassword'),
    });
  }
  // convenience getter for easy access to form fields
  get f() { return this.form.controls; }

  onCancel() {
    if (this.signup.ccfirstname != undefined) {
      this.router.navigate(['/partner/payment'])
    }
    else {
      this.router.navigate(['/partner/package'])
    }
  }

  showEsignAuth() {
    this.esignmodal.show();
  }
  showAgreement() {
    this.agreementmodal.show();
  }

  sign() {
    var sig = this.signbox.saveSignature();
    this.signup.clientagreementsignature = sig;
    if (sig.length <= 3400) {
      this.agreementBox.checked = false;
      this.signup.agreement = false;
      this.form.setErrors({ 'invalid': true });
      this.agreementsignmodal.hide();
      this.alertService.error("Signature is invalid, please try again.");
    }
    else {
      this.form.setErrors(null);
      this.form.valid;
      this.agreementBox.checked = true;
      this.signup.agreement = true;
      this.agreementsignmodal.hide();
    }
  }
  clientAgreement(checked: boolean) {
    if (this.isDisabled) {
      this.alertService.error("You must agree to the e-sign authorization first.")
    }
    if (checked) {
      this.agreementsignmodal.show();
    }
    else {
      this.agreementBox.checked = false;
    }

  }

  eSignAuth(checked: boolean) {
    if (checked) {
      this.isDisabled = false;
    } else {
      if (this.form.controls.agreement.value == true) this.form.patchValue({ agreement: false });
      this.isDisabled = true;
    }
  }

  closeAgreement() {
    this.agreementmodal.hide();
  }

  cancelSign() {
    this.agreementsignmodal.hide();
    this.signup.agreement = false;
    this.form.setErrors({ 'invalid': true });
    this.agreementBox.checked = false;
  }

  updateInvalidTooltip() {
    if (this.form.invalid) {
      var controlName;
      Object.keys(this.form.controls).forEach(x => {
        if (this.form.get(x).invalid) {
          if (x == "email") {
            controlName = "Email";
          }
          if (x == "password") {
            controlName = "Password";
          }
          if (x == "confirmPassword") {
            controlName = "Confirm Password";
          }
          if (x == "legalCompanyName") {
            controlName = "Legal Company Name";
          }
          if (x == "billToAddress") {
            controlName = "Business Address";
          }
          if (x == "billToCity") {
            controlName = "City";
          }
          if (x == "billToState") {
            controlName = "State";
          }
          if (x == "billToZip") {
            controlName = "Zip Code";
          }
          if (x == "ownershiptype") {
            controlName = "Ownership Type";
          }
          if (x == "billToZip") {
            controlName = "Zip Code";
          }
          if (x == "clientagreementpermissiblepurpose") {
            controlName = "Permissible Purpose";
          }
          if (x == "mobilephonenumber") {
            controlName = "Mobile Phone";
          }
          if (x == "agreement") {
            controlName = "Agreement for Service";
          }
          if (x == "authorization") {
            controlName = "E-Signature Authorization";
          }

          this.invalidTooltipList = this.invalidTooltipList + ", \n" + controlName;
        }
      })
    }
  }

  resetInvalidTooltip() {
    this.invalidTooltipList = "";
  }

  closeESign() {
    this.esignmodal.hide();
  }

  onSubmit() {

    this.showAgreementRestrictor = true;
    this.submitted = true;
    this.getClientAgreement();
    this.alertService.clear();

    if (this.agreementBox.checked == false) {
      this.alertService.error("You must sign the agreement for services to continue.")
      return;
    }

    if (this.form.invalid) {
      this.alertService.error("Please ensure your account information is correct")
      return;
    }

    if (this.signup.middleName != null) {
      this.signup.middleName = this.signup.middleName.trim();
    }

    Object.keys(this.form.value).forEach(x => {
      this.signup[x] = this.form.value[x];
    })

    this.loading = true;
    this.loader.show();

    this.signupService.saveFinalSignup(this.signup).subscribe((data => {

      if (data.error == true) {
        this.loading = false;
        this.loader.hide();
        this.alertService.error(data.message)
        return;
      }
      else {
        this.signupService.savePackage(this.signup);
        this.partnerComponent.accountStep.visited = true;
        this.router.navigate(['/partner/credentialing']);
      }
    }));

  }

  getStateByZip() {
    var tempZip = this.form.controls.billToZip.value;
    if (tempZip != '') {
      this.geographyService.getStatesByPostalCode(tempZip).subscribe(data => {
        if (data[0] != undefined) {
          this.selectedState = data[0];
          this.form.patchValue({
            billToState: this.selectedState.name
          });
        }
        else {
          this.alertService.error("Make sure you have a valid zip")
          this.form.patchValue({
            billToState: ''
          });
        }
      });
    }
  }

  getClientAgreement() {
    this.signupService.getLegalForm(this.clientLegalFormGuid).subscribe(x => {
      this.clientFullName = this.signup.firstName + " " + this.signup.lastName;
      let today = new Date().toLocaleDateString();

      var replace = this.clientLegalFormHTML = x.replaceAll('[[clientname]]', this.clientFullName);
      replace = replace.replaceAll('[[signaturedate]]', today)
      replace = replace.replace('[[clientaddress]]', this.signup.billToAddress);
      replace = replace.replace('[[signername]]', this.clientFullName);
      replace = replace.replace('[[purpose]]', this.signup.clientagreementpermissiblepurpose);
      replace = replace.replace('[[clientnatureofbusiness]]', this.signup.clientnatureofbusiness);
      this.clientLegalFormHTML = replace;
    });
    if (this.showAgreementRestrictor == false) {
      this.showAgreement();
    }
  }


  showValidation(field: string) {
    if (this.form.controls[field].invalid && this.form.controls[field].dirty) {
      this[field + "Invalid"] = true;
    }
    else {
      this[field + "Invalid"] = false;
    }
  }
}

function hasNumbers(control: AbstractControl): { [key: string]: any } | null {
  const testedPassword: string = control.value;
  const regex = /[0-9]/;
  if (regex.test(testedPassword) == true && testedPassword != '') {
    return null;
  }
  else {
    return { 'hasNumbers': true };
  }
}

function hasLength(control: AbstractControl): { [key: string]: any } | null {
  const testedPassword: string = control.value;
  if (testedPassword != '' && testedPassword.length >= 8) {
    return null;
  }
  else {
    return { 'hasLength': true };
  }
}

function hasSpecialCharacters(control: AbstractControl): { [key: string]: any } | null {
  const testedPassword: string = control.value;
  const regex = /[-{}+!@$%^&*().]/;
  if (regex.test(testedPassword) == true) {
    return null;
  }
  else {
    return { 'hasSpecialCharacters': true };
  }
}

function hasUpper(control: AbstractControl): { [key: string]: any } | null {
  const testedPassword: string = control.value;
  const regex = /[A-Z]/;
  if (regex.test(testedPassword) == true) {
    return null;
  }
  else {
    return { 'hasUpper': true };
  }
}

function hasLower(control: AbstractControl): { [key: string]: any } | null {
  const testedPassword: string = control.value;
  const regex = /[a-z]/;
  if (regex.test(testedPassword) == true) {
    return null;
  }
  else {
    return { 'hasLower': true };
  }
}